import { render } from "./InfraBand.vue?vue&type=template&id=c0bc4f6a&scoped=true"
import script from "./InfraBand.vue?vue&type=script&lang=js"
export * from "./InfraBand.vue?vue&type=script&lang=js"

import "./InfraBand.vue?vue&type=style&index=0&id=c0bc4f6a&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0bc4f6a"]])

export default __exports__